import React from 'react';
import './EPDPage.css'; // You can create this for styling or inline style instead

const tileData = [
  {
    title: 'EPD Australasia',
    url: 'https://epd-australasia.com/epd-search/',
    image: '/images/EPD-Australasia.png' // Store your image here
  },
  {
    title: 'Environdec',
    url: 'https://www.environdec.com/home',
    image: '/images/EPD-International.png'
  },
  {
    title: 'Thinkstep ANZ',
    url: 'https://www.thinkstep-anz.com/services/product/environmental-product-declarations/',
    image: '/images/thinkstep.png'
  }
];

const EPDPage = () => {
  return (
    <div className="epd-page">
      <h1>Environmental Product Declaration Resources</h1>
      <p>Click any of the tiles below to explore external EPD resources.</p>
      
      <div className="tile-container">
        {tileData.map((tile, index) => (
          <a
            key={index}
            href={tile.url}
            target="_blank"
            rel="noopener noreferrer"
            className="epd-tile"
          >
            <img src={tile.image} alt={tile.title} />
            <h3>{tile.title}</h3>
          </a>
        ))}
      </div>
    </div>
  );
};

export default EPDPage;
